import { StatusBadge } from '../ui/StatusBadge'
import { FileText, Bookmark } from 'lucide-react'

interface ContentSource {
  id: number
  title: string
  url: string
  domain?: string
  snippet?: string
}

interface ContentPiece {
  id: string
  title: string | null
  status: string | null
  word_count: number | null
  current_version: number | null
  sources?: ContentSource[]
  research_summary?: string
  research_key_findings?: string[]
}

interface ContentTabsProps {
  pieces: ContentPiece[]
  activeId: string | null
  onSelect: (id: string) => void
}

export function ContentTabs({ pieces, activeId, onSelect }: ContentTabsProps) {
  if (pieces.length <= 1) return null

  return (
    <div className="border-b border-slate-200 bg-white">
      <div className="flex overflow-x-auto scrollbar-thin">
        {pieces.map((piece, index) => {
          const isActive = piece.id === activeId
          return (
            <button
              key={piece.id}
              onClick={() => onSelect(piece.id)}
              className={`
                flex items-center gap-2 px-4 py-3 text-sm font-medium whitespace-nowrap
                border-b-2 transition-all duration-200 min-w-0
                ${
                  isActive
                    ? 'border-emerald-500 text-emerald-700 bg-emerald-50/50'
                    : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300 hover:bg-slate-50'
                }
              `}
            >
              <FileText className="w-4 h-4 flex-shrink-0" />
              <span className="truncate max-w-[200px]">
                {piece.title || `Pieza ${index + 1}`}
              </span>
              <StatusBadge status={piece.status || 'draft'} className="text-[10px] px-1.5 py-0" />
              {piece.word_count && (
                <span className="text-xs text-slate-400 ml-1">
                  {piece.word_count}w
                </span>
              )}
              {piece.sources && piece.sources.length > 0 && (
                <span
                  className="text-xs text-slate-500 flex items-center gap-1 ml-1"
                  title={`${piece.sources.length} fuente${piece.sources.length !== 1 ? 's' : ''}`}
                >
                  <Bookmark className="w-3 h-3" />
                  {piece.sources.length} fuentes
                </span>
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}
